import React, { useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Festival from "./pages/Festival";
import Guestbook from "./pages/Guestbook";
import Map from "./pages/Map/Map";
import BarMenu from "./pages/BarMenu";
import Programme from "./pages/Programme/Programme";

function App() {
    const [themeMode, setThemeMode] = useState(
        window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark"
    );
    const theme = createTheme({ palette: { mode: themeMode } });

    const toggleTheme = () => {
        setThemeMode(themeMode === "light" ? "dark" : "light");
    };
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Layout toggleTheme={toggleTheme}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/gjestebok" element={<Guestbook />} />
                        <Route path="/festival" element={<Festival />} />
                        <Route path="/festival/program" element={<Programme />} />
                        <Route path="/festival/kart" element={<Map />} />
                        <Route path="/festival/bar" element={<BarMenu />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
